import { watch } from 'vue';

/**
 * Resolves once the given Auth0/DE Auth reactive instance has finished its initial
 * load (i.e. `instance.loading` becomes false). Treats a missing instance as already
 * resolved (nothing to wait for) rather than dereferencing undefined.
 */
export function waitForAuthLoaded(authInstance) {
    if (!authInstance || !authInstance.loading) {
        return Promise.resolve();
    }

    return new Promise((resolve) => {
        const stopWatch = watch(
            () => authInstance.loading,
            (loading) => {
                if (loading === false) {
                    stopWatch();
                    resolve();
                }
            },
        );
    });
}
